export const gatewayConfigStyles = {
  commonIconButton: {
    width: 36,
    height: 36,
    padding: 0,
  },
  iconContainer: {
    position: "relative",
    width: 24,
    height: 24,
  },
  trendingIcon: {
    position: "absolute",
    bottom: -2,
    right: -2,
    background: "white",
    borderRadius: "50%",
    padding: "0.5px",
    boxShadow: "0 0 2px rgba(0,0,0,0.15)",
  },
  plusIcon: {
    position: "absolute",
    bottom: -2,
    right: -2,
    background: "white",
    borderRadius: "50%",
    padding: "1px",
    boxShadow: "0 0 2px rgba(0,0,0,0.15)",
  },
  weekSelector: {
    px: 2,
    py: 1,
    borderRadius: "20px",
    border: "1px solid #ccc",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: 500,
    transition: "all 0.2s ease",
    borderColor: "#ff5d17",
  },
};
